/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useState } from 'react';
import { string, shape, func } from 'prop-types';
import { Button, TextField, CardMedia } from '@one-thd/sui-atomic-components';

export const RebateLocation = ({
  localAreaData,
  setLocalZip
}) => {
  const [locationInputField, setLocationInputField] = useState('');

  const onInputChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setLocationInputField(value);
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    setLocalZip(locationInputField);
  };

  return (
    <div className="sui-flex sui-items-center sui-w-full xl:sui-w-auto">
      <div className="lg:sui-flex sui-whitespace-nowrap sui-text-base
      sui-bg-subtle lg:sui-py-[10px] sui-mt-2 sui-px-2"
      >
        <CardMedia
          src="https://assets.thdstatic.com/images/v1/poi-symbol.svg"
          alt="Search Zipcode"
          className="sui-w-[20px] sui-h-[20px]"
        />
        {localAreaData.cityState}
      </div>
      <div className="sui-flex-1">
        <TextField
          placeholder="Add Zip to Find"
          onChange={onInputChange}
          value={locationInputField}
          fullWidth
          mask="99999"
          InputProps={{
            style: { width: '100%' },
          }}
          className="sui-text-base"
        />
      </div>
      <div className="sui-pt-2 sui-ml-2">
        <Button
          type="submit"
          data-testid="check-bttn"
          variant="secondary"
          onClick={handleFormSubmit}
        >
          Check
        </Button>
      </div>
    </div>
  );
};

RebateLocation.propTypes = {
  localAreaData: shape({
    cityState: string
  }).isRequired,
  setLocalZip: func.isRequired
};

RebateLocation.defaultProps = {};

RebateLocation.displayName = 'RebateLocation';
